/**
 * Firestore retries a create when the first write landed but the ack was lost.
 * That second create reports "Document already exists" even though the heartbeat
 * is already stored.
 */
export function isIgnoredCrmSessionHeartbeatError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const code = String((err as { code?: unknown }).code ?? '');
  if (code === 'already-exists' || code.endsWith('/already-exists')) return true;
  const message = String((err as { message?: unknown }).message ?? '');
  return message.includes('Document already exists');
}
